export const CRM_COLUMN_COLOR_CLASS_MAP = {
  slate: {
    border: 'border-b-n-slate-9',
    dot: 'bg-n-slate-9',
    badge: 'bg-n-slate-9/10 text-n-slate-12',
  },
  blue: {
    border: 'border-b-n-blue-9',
    dot: 'bg-n-blue-9',
    badge: 'bg-n-blue-9/10 text-n-blue-text',
  },
  amber: {
    border: 'border-b-n-amber-9',
    dot: 'bg-n-amber-9',
    badge: 'bg-n-amber-9/10 text-n-slate-12',
  },
  emerald: {
    border: 'border-b-n-teal-9',
    dot: 'bg-n-teal-9',
    badge: 'bg-n-teal-9/10 text-n-teal-11',
  },
};

export const CRM_COLUMN_COLOR_TOKENS = Object.keys(CRM_COLUMN_COLOR_CLASS_MAP);

export const getColumnColorClasses = token => {
  return CRM_COLUMN_COLOR_CLASS_MAP[token] || CRM_COLUMN_COLOR_CLASS_MAP.slate;
};
